import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useCms } from '../context/CmsContext';

const fallbackFaqItems = [
  {
    question: "Hvilke typer opgaver og materialer kan I rense med laser?",
    answer: `Vi udfører non-abrasiv laserrensning på en lang række overflader og materialer. Vi renser effektivt natursten som eksempelvis granit og sandsten, samt beton, mursten og metal. Desuden kan vi i visse tilfælde rense træ, hvilket dog kræver en helt særlig præcision og kalibrering af udstyret.

Vores teknologi kan fjerne stort set alle former for genstridige belægninger. Derfor rykker vi oftest ud til opgaver på bygninger og anlæg, der involverer fjernelse af:
- Graffiti og tags
- Sod, skidt og atmosfærisk snavs
- Udtræk på mure og beton (f.eks. salpeter- eller kalkudtræk)
- Rust, olie og fedt

Da vi har et dybtgående materialekendskab, tilpasser vi altid laseren til den enkelte opgave. Herved kan vi håndtere alt fra grove industrijern til de mest følsomme, fredede facader. Du er altid velkommen til at kontakte os, så vi kan drøfte din specifikke overflade.`
  },
  {
    question: "Skader laserrensning overfladen på bygninger og murværk?",
    answer: `Nej, overhovedet ikke – så længe arbejdet udføres af en fagmand. Laserrensning er nemlig en fuldstændig ikke-slibende (non-abrasiv) metode.

Med vores dybe materialekendskab kalibrerer og indstiller vi altid laseren præcist til den specifikke overflade. Det er en sand kunst at vide nøjagtigt, hvornår strålen skal stoppes. Derfor sætter vi os grundigt ind i materialernes præcise maksimumgrænser og tolerancer på forhånd. Herved sikrer vi effektivt, at laseren udelukkende nedbryder snavs, sod eller graffiti.

Den underliggende overflade efterlades derimod 100 procent uberørt. Dette gør i sidste ende metoden fuldstændig ufarlig og ekstremt sikker for dine materialer.`
  },
  {
    question: "Kører I ud til opgaver i hele Danmark?",
    answer: `Ja, det gør jeg. ECOLASER er baseret på Djursland, men efterspørgslen på professionel laserrensning er stor. Derfor ligger omkring 80 procent af mine opgaver faktisk på Sjælland i øjeblikket.

Jeg rykker hurtigt ud til opgaver i hele landet. Dette gælder både i Jylland, på Fyn, Sjælland og alle brofaste øer. Desuden spiller det ingen rolle, om der er tale om en erhvervsopgave, en fredet facade eller en specialopgave for private. Jeg pakker blot det mobile udstyr og kommer ud til din adresse.

Kørslen planlægges altid yderst effektivt. Herigennem sikrer jeg, at du altid får en fair og gennemskuelig pris på dit projekt.`
  },
  {
    question: "Er laserrensning en kemifri metode?",
    answer: `Ja, det er en af de absolut mest kemifrie rensemetoder på markedet. For det første bruger vi overhovedet ikke noget af vores kostbare grundvand. Dette gør i sig selv metoden ekstremt ressourcebesparende. For det andet bruges der absolut ingen skrap kemi eller traditionelle blæsemidler under processen.

Der kan dog forekomme en minimal mængde tør aske fra det lag, der renses af. Derfor suges dette restprodukt op med det samme via vores professionelle udsugning. Det fanges effektivt i godkendte HEPA-filtre. Desuden bortskaffes alt materialet i fuld overensstemmelse med gældende lovgivning og vejledninger.

Dette sikrer en fuldstændig ren proces. Herved undgår vi enhver form for forurening af den omkringliggende natur eller det lokale kloaksystem.`
  },
  {
    question: "Er der lang ventetid eller tørretid efter en laserrensning?",
    answer: `Nej, overhovedet ikke. Da vi udfører en fuldstændig kemifri og tør proces uden brug af vand, er der absolut ingen tørretid bagefter. Så snart laseren har passeret overfladen, er det endelige resultat synligt med det samme. Derfor kan det rensede område eller emne tages i brug igen i samme sekund, som vi er færdige.

Dette koncept minimerer effektivt både nedetid og ventetid. Herved sikrer vi en hurtig proces for både virksomheder, byggepladser og private boligejere.`
  },
  {
    question: "Foregår laserrensningen hos jer, eller kommer I ud til opgaven?",
    answer: `Vi kommer ud til dig. Vores professionelle laserudstyr er ekstremt mobilt og fuldstændig uafhængigt af eksterne faciliteter. Det er desuden designet så fleksibelt, at vi uden problemer kan tage udstyret med op i højden på både lifte og stilladser.

Dette betyder, at vi kan udføre opgaven direkte på stedet. Det gælder uanset, om det er en højtliggende facade, en fastmonteret industrimaskine eller en fredet bygning. Derfor slipper du helt for besværlig demontering. Herved sparer du også de tunge og dyre transportomkostninger.`
  },
  {
    question: "Hvordan fungerer laserrensning, og hvad kræver det at betjene udstyret?",
    answer: `Kort fortalt fungerer teknologien ved, at laseren udsender ultrakorte, intense lyspulser. Når laserlyset rammer overfladen, absorberes energien med det samme af snavset, graffitien eller rusten. Herved fordamper belægningen øjeblikkeligt via en proces, der kaldes ablation. Selve underlaget reflekterer blot lyset og forbliver fuldstændig uberørt.

Hos ECOLASER benytter vi udelukkende professionelt, CE-godkendt udstyr. Dette valg garanterer altid den højeste standard inden for driftssikkerhed. Man ser desværre billige kopi-modeller fra Kina på markedet i dag, som sælges uden de korrekte godkendelser. Det er derimod overhovedet ikke det, vi arbejder med. Ucertificeret udstyr kan være meget ustabilt, og i værste fald ødelægger det de dyre materialer.

Laserrens er en højteknologisk proces, som kræver den helt rette maskinkvalitet. Desuden kræver det et dybtgående kendskab til lasersikkerhed samt en helt præcis kalibrering. Det er professionelt præcisionsarbejde, der sikrer dig det bedste og sikreste resultat hver evig eneste gang.`
  },
  {
    question: "Hvordan håndterer I sikkerheden under en laserrensning?",
    answer: `Sikkerhed er min absolut højeste prioritet. Derfor arbejder jeg altid strengt ud fra Arbejdstilsynets regler og gældende retningslinjer for lasersikkerhed. Inden arbejdet går i gang, etablerer jeg en kontrolleret laserzone med tydelig skiltning. Desuden sørger jeg for den nødvendige afskærmning, så udefrakommende ikke kan kigge direkte ind i laserstrålen.

Under selve arbejdet bærer jeg altid godkendte lasersikkerhedsbriller og det rette sikkerhedsudstyr. Jeg sikrer herved altid, at ingen personer overhovedet befinder sig i farezonen uden beskyttelse under rensningen.

Du kan derfor være helt tryg ved at have mig gående på opgaven. Dette gælder uanset, om det er på en travl byggeplads, hjemme ved dit private hus eller i din virksomhed.`
  },
  {
    question: "Kan laserrens bruges indendørs?",
    answer: `Ja, laserrens er fuldstændig unik til indendørs afrensning, netop fordi vi overhovedet ikke bruger vand.

Ved traditionelle rensemetoder som højtryksspuling, sandblæsning eller kemisk afrensning indendørs opstår der enorme udfordringer med vandskader, fugtophobning i vægge og gulve samt svineri fra blæsemidler. Med laserrens undgår du alt dette. Det er en 100% tør proces, hvor belægningen (f.eks. sod efter brand, skimmelsvamp, maling eller rust) fordamper øjeblikkeligt.

Det forstøvede restprodukt suges direkte op ved kilden via vores professionelle HEPA-udsugning, så der efterlades ingen kemikalierester eller fugt. Det gør metoden ideel til indendørs brug i beboelse, kældre, produktionshaller, historiske rum og industrien.`
  }
];

export default function FAQ() {
  const { faq, siteSettings, getPage } = useCms();
  const [openIndex, setOpenIndex] = useState(null);

  const pageData = getPage('faq');
  const itemsToDisplay = faq && faq.length > 0 ? faq.map(item => ({
    question: typeof item.question === 'object' ? item.question?.da : item.question,
    answer: typeof item.answer === 'object' ? item.answer?.da : item.answer
  })) : fallbackFaqItems;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>FAQ om laserrensning – Få svar på dine spørgsmål | ECOLASER</title>
        <meta name="description" content="Har du spørgsmål om laserrensning? Få svar på alt om sikkerhed, CE-godkendt udstyr og materialer her. ECOLASER er baseret på Djursland og kører i hele DK." />
        <meta property="og:title" content="FAQ om laserrensning – Få svar på dine spørgsmål | ECOLASER" />
        <meta property="og:description" content="Har du spørgsmål om laserrensning? Få svar på alt om sikkerhed, CE-godkendt udstyr og materialer her. ECOLASER er baseret på Djursland og kører i hele DK." />
        <html lang="da" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative pt-44 pb-28 md:pt-52 md:pb-36 overflow-hidden bg-zinc-950">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/assets/9272dfda-3124-4579-9ee4-d6842e5967c6/front-kbh-chr-d-9-high.webp?width=1800&quality=80&format=auto"
            alt="Ecolaser baggrund"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/60 to-zinc-950/40" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-left flex flex-col items-start gap-4">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight">FAQ om laserrensning</h1>
          <p className="text-zinc-200 text-sm md:text-base max-w-2xl leading-relaxed">
            Velkommen til ECOLASERs FAQ. Her kan du dykke ned i de mest almindelige spørgsmål om laserrensning. Derfor har jeg samlet de vigtigste svar, så du nemt kan finde information om alt fra materialer og geografi til sikkerhed under arbejdet.
          </p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl space-y-4">
            {itemsToDisplay.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="bg-zinc-50 border border-zinc-200 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-sm"
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="w-full flex items-center justify-between p-6 text-left text-zinc-900 hover:text-brand-green transition-colors duration-200 cursor-pointer"
                  >
                    <span className="font-bold text-base md:text-lg leading-snug pr-4">
                      {item.question}
                    </span>
                    <div className={`w-8 h-8 rounded-lg bg-white border border-zinc-200 flex items-center justify-center shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 border-brand-green/30 text-brand-green' : 'text-zinc-500'}`}>
                      <i className="fa-solid fa-chevron-down text-xs" />
                    </div>
                  </button>

                  <div
                    className={`transition-all duration-300 ease-in-out overflow-hidden ${
                      isOpen ? 'max-h-[1000px] border-t border-zinc-200' : 'max-h-0'
                    }`}
                  >
                    <div className="p-6 text-zinc-600 text-sm md:text-base leading-relaxed space-y-4 whitespace-pre-line">
                      {item.answer}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-zinc-50 py-24">
        <div className="max-w-4xl mx-auto px-6 text-center flex flex-col items-center gap-6">
          <h2 className="text-3xl md:text-5xl font-bold text-zinc-900 leading-tight">
            Ingen opgaver er ens
          </h2>
          <p className="text-zinc-600 text-sm md:text-base max-w-xl leading-relaxed">
            Hvis du står med en specifik overflade eller en udfordring, sidder jeg klar med en professionel vurdering. Derfor kan du altid hurtigt få den rette hjælp til at komme videre med dit projekt.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-4 w-full sm:w-auto">
            <a
              href={siteSettings.phoneTel}
              className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-light text-white font-bold px-8 py-4 rounded-lg text-sm uppercase tracking-wider transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-phone" /> Ring direkte: {siteSettings.phone}
            </a>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto bg-white hover:bg-zinc-100 text-zinc-800 font-bold px-8 py-4 rounded-lg text-sm uppercase tracking-wider border border-zinc-200 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-envelope" /> Indhent tilbud
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
